export function extractDomain(email: string): string {
  const parts = email.split('@');
  return parts.length === 2 ? parts[1] : '';
}

export function isDomainMatch(email: string, orgDomain: string): boolean {
  const domain = extractDomain(email);
  if (!domain) return false;
  return domain.toLowerCase() === orgDomain.toLowerCase();
}
